document.addEventListener('DOMContentLoaded', () => {
  // Mobile only
  // if (!window.matchMedia('(max-width: 749px)').matches) return;

  const container = document.querySelector('.product-details');
  if (!container) return;

  // Check theme setting
  if (container.dataset.autoCloseDescription !== 'true') return;

  /**
   * Ritual renders Product Description as its own <details>
   * We safely detect it by block type OR summary text
   */
  const descriptionAccordion = Array.from(
    container.querySelectorAll('details')
  ).find(details => {
    const summary = details.querySelector('summary');
    return summary && /description/i.test(summary.textContent);
  });

  if (!descriptionAccordion) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          descriptionAccordion.removeAttribute('open');
        }
      });
    },
    { threshold: 0.15 }
  );

  observer.observe(descriptionAccordion);
});
